function isElementVerticallyScrollable (el) {
    if (!el) return false;

    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    return (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
}

export const findScrollableParent = (el, container) => {
    while (el && el !== container) {
        if (isElementVerticallyScrollable(el)) {
            return el;
        }
        el = el.parentElement;
    }

    if (isElementVerticallyScrollable(container)) {
        return container;
    }

    return null;
}